export const CONCIERGE_PATHNAME = '/concierge/';
export const AUTH_ACTION = {
  CONCIERGE: {
    creativeId: 'concierge',
    signInTrackingId: 'concierge_begin_sign_up',
    signOutTrackingId: 'concierge_sign_out',
  },
};
